import React, { useMemo } from 'react'
import { Grid, Label } from 'semantic-ui-react'
import { AddBtn } from '../../../../commonComponents/AddBtn'
import DeleteIcon from '../../../../commonComponents/deleteIcon'
import { useToggle } from '../../../../hooks'

const ContainerDropdown = ({
  disabled = false,
  onDelete,
  onSelect,
  selectedContainerList,
  dataSource
}) => {
  const [toggleValue, setToggleValue] = useToggle(false)

  const setDisplayContainerNumbers = React.useMemo(() => {
    if (!selectedContainerList) return null
    return selectedContainerList.map((item, index) => {
      return (
        <Label key={index}>
          {item.containerNumber}
          <DeleteIcon id={`deleteContainer-${item.containerAssociationId}`} onClick={() => onDelete(item)} iconName='delete' />
        </Label>
      )
    })
  }, [selectedContainerList, disabled])

  const removeAlreadySelectedItem = useMemo(() => {
    if (!selectedContainerList) return dataSource
    return dataSource.filter(
      (elem) =>
        !selectedContainerList.find(
          ({ containerNumber }) => elem.containerNumber === containerNumber
        )
    )
  }, [dataSource, selectedContainerList])

  return (
    <Grid>
      <Grid.Row>
        <Grid.Column
          width='16'
          className='divFormFeild  border-bottom   b-rw-0  b-blr-5 '
          style={{
            backgroundColor: 'white',
            border: '1px solid #1765AE',
            borderRadius: '5px',
          }}
        >
          <label className='label-address' style={{ verticalAlign: 'middle' }}>
            <span className='ui black label input-box-number'>31</span>
            Container Numbers
          </label>
          <span>
            <Label.Group style={{ marginLeft: '3px', marginTop:'5px', padding: '0.3rem 0rem' }}>
              {setDisplayContainerNumbers}

              <AddBtn
                style={{
                  height: '20px',
                  width: '41px',
                  color: 'green',
                  fontSize: '9px',
                  border: '1px solid green',
                  backgroundColor: 'white',
                  textAlign: 'center',
                  padding: '1px 0px 0px 0px',
                  position: 'relative',
                  marginLeft: '4px',
                }}
                onClick={() => setToggleValue()}
                // onBlur={() => setShowContainerList(false)}
                disabled = {disabled} 
                text='Add'
                iconClass=''
              ></AddBtn>
            </Label.Group>
          </span>
          {toggleValue && removeAlreadySelectedItem?.length > 0 && (
            <div
              className='productHistory'
              style={{
                width: '400px',
                height: '100px',
                overflow: 'scroll',
              }}
            >
              {removeAlreadySelectedItem.map((currentItem, index) => (
                <React.Fragment key={currentItem.containerNumber + ' ' + index}>
                  <a
                    className='dropdownlink'
                    onClick={() => {
                      onSelect(currentItem)
                      setToggleValue()
                    }}
                  >
                    <table className='productHistoryTable'>
                      <tbody>
                        <tr>
                          <td colSpan='2' className='displaySelcted'>
                            <span
                              style={{
                                whiteSpace: 'nowrap',
                                textTransform: 'uppercase',
                              }}
                            >
                              <h5>{currentItem.containerNumber || ''}</h5>
                            </span>
                          </td>
                        </tr>

                        <hr style={{ width: '158%' }} />
                      </tbody>
                    </table>
                  </a>
                </React.Fragment>
              ))}
            </div>
          )}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}

const MemoizeContainerDropdown = React.memo(ContainerDropdown)
export { MemoizeContainerDropdown }
